import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/AnimalInventoryForm";
import AnimalTab from "../components/AnimalInventoryTab";
import Card from "components/card";
import { ANIMAL_TYPE_SHEEP } from "variables/constants";

const ViewSheep = () => {
	const { sheepId } = useParams();

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<RegisteredAnimalsForm recordId={sheepId} mode="view" animalTypeId={ANIMAL_TYPE_SHEEP}/>

				<div className="mt-4 mb-4">
					<Card extra={"w-full h-full p-4"}>
						<AnimalTab recordId={sheepId}/>
					</Card>
				</div>
	      </div>
	    </div>
    );
};

export default ViewSheep;